// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"251b5536","82":"a779c1b3","105":"e0d0f815","365":"41b72966","397":"fa28fda0","532":"49327644","722":"65753e51","937":"d7a1634e","971":"388b545d"}[chunkId] + ".chunk.js";
};